import React from "react";
import {
  Container,
  Typography,
  Link,
} from "@mui/material";
import "../App.css";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
export default function Contacto() {
  return (
    <Container
      sx={{
        display: "block",
        width: "80%",
        textAlign: "center",
        marginTop: 10,
        marginBottom: 0,
        paddingBottom:10
      }}
      data-aos="fade-right"
      data-aos-offset="300"
      data-aos-easing="ease-in-sine"
      data-aos-duration="1500"
      id="contacto"
    >
      <Typography variant="h2">Siguenos en nuestras redes sociales</Typography>
      <Typography variant="button">
        Date cuenta de las proximas noticias en We can dig it!
      </Typography>
      <Container
        maxWidth="xl"
        sx={{
          display: { md: "flex", xs: "none" },
          flexWrap: "wrap",
          justifyContent: "space-around",
          width: "80%",
          textAlign: "center",
          paddingBottom: "5%",
          paddingTop: "5%",
        }}
      >
        <Link href="https://twitter.com/wecandigitgame" underline="hover">
          <TwitterIcon fontSize="large" color={"secondary"}/>
        </Link>
        <Link href="https://www.instagram.com/wecandigitgame/" underline="hover">
          <InstagramIcon fontSize="large" color={"secondary"}/>
        </Link>
        <Link href="https://itch.io/" underline="hover">
          <ArrowOutwardIcon fontSize="large" color={"secondary"}/>
        </Link>
        <Link href="https://es-la.facebook.com/" underline="hover">
          <FacebookIcon fontSize="large" color={"secondary"}/>
        </Link>
      </Container>
      <Container
        maxWidth="xl"
        sx={{
          display: { md: "none", xs: "block" },
          width: "80%",
          textAlign: "center",
          paddingBottom: "5%",
          paddingTop: "5%",
        }}
      >
         <Link href="https://twitter.com/wecandigitgame" underline="hover">
          <TwitterIcon fontSize="large" color={"secondary"}/>
        </Link>
        <Link href="https://www.instagram.com/wecandigitgame/" underline="hover">
          <InstagramIcon fontSize="large" color={"secondary"}/>
        </Link>
        <Link href="https://itch.io/" underline="hover">
          <ArrowOutwardIcon fontSize="large" color={"secondary"}/>
        </Link>
        <Link href="https://es-la.facebook.com/" underline="hover">
          <FacebookIcon fontSize="large" color={"secondary"}/>
        </Link>
      </Container>
    </Container>
  );
}
